import React from 'react';
import numeral from 'numeral';
import { Row, Col } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';

import './ComparisonTooltip.css';

import { regionLabels } from '../../../charts/TvSurveyRosace/TvSurveyRosace'

import { PARAM_ADVANCE_MODE, PARAM_DETAIL_LEVEL } from '../../SurveySummary/SurveySummary';

const ComparisonSimpleTooltip = (props) => {
  const { tooltip, city, intl } = props;
  const { locale } = intl;
  const localeRef = locale === 'en' ? 'En' : 'Nl';
  if (tooltip && tooltip.content && tooltip.position){
    const {content, position} = tooltip;
    const {data} = content;
    let style 
    if(position.y < window.innerHeight / 2){
      style = {
        left: `${position.x}px`,
        top: `${position.y}px`,
        maxWidth: '400px',
        wordWrap: 'break-word',
      }
    } else {
      style = {
        left: `${position.x}px`,
        bottom: `${window.innerHeight - position.y}px`,
        maxWidth: '400px',
        wordWrap: 'break-word',
      }
    }
    
    if (content.comparatorData && content.comparatorData[0] && content.comparatorData[1]){
      if (!content.comparatorData[0].color) content.comparatorData[0].color = 'dodgerblue'; 
      if (!content.comparatorData[1].color) content.comparatorData[1].color = 'grey'; 
    }
    return (
      <div className="comparisonTooltip" style={style}>
        {/*<Breadcrumb>
          <Breadcrumb.Item>{data.mainCategory.toUpperCase()}</Breadcrumb.Item>
          <Breadcrumb.Item>{data.subCategory.toUpperCase()}</Breadcrumb.Item>
          <Breadcrumb.Item>{data.summaryEn.toUpperCase()} ({data.question.ref})</Breadcrumb.Item>
        </Breadcrumb>*/}
        {/*content.title && <h2>{content.title}</h2> */}
        {data.preQuestionEn && <h5>{data[`preQuestion${localeRef}`]}</h5>}
        <h2>{data[`question${localeRef}`]}</h2>
        {data &&
          <div> 
            { (data.question.type !== 'moreLess' && PARAM_ADVANCE_MODE) &&
              <div>
                <h5><FormattedMessage id="app.global"/></h5>
                <div style={{ paddingLeft: 8 }}>
                  <div><strong><FormattedMessage id="app.agreementRatio"/></strong>: {numeral(data.weightedAgreementProportion).format('0 %')} (vs {numeral(data.past.weightedAgreementProportion).format('0 %')})</div>
                  <div><strong><FormattedMessage id="app.averageScore"/></strong>: {numeral(data.weightedAvg - (data.question.type === 'binary' ? 1 : 0)).format('0.00')} (vs {numeral(data.past.weightedAvg - (data.question.type === 'binary' ? 1 : 0)).format('0.00')})</div>
                </div>
              </div>
            }
            <h5 style={{ marginTop: 16}}><FormattedMessage id="app.details"/> (2019{ (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <span> vs. 2017</span>})</h5>
            {
              (data.question.type === 'agreementLevel' && PARAM_DETAIL_LEVEL === 5) && 
              <div style={{ paddingLeft: 8 }}>
                <Row type="flex">
                  <Col span={10}>
                    <strong><FormattedMessage id="app.stronglyAgree"/></strong>
                  </Col>
                  <Col span={6}>
                    <strong>{Math.round(data.weightedDistribution[4]/data.totalWeight * 100)}%</strong> { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <small>vs. {Math.round(data.past.weightedDistribution[4]/data.past.totalWeight * 100)}%</small>}
                  </Col>
                  <Col span={8}>
                    <svg height="18px" width="100%">
                      <rect height="18px" width="100%" fill="#efefef" rx="4"></rect>
                      <rect height="18px" width={`${data.weightedDistribution[4]/data.totalWeight * 100}%`} fill={data.mainColor} rx="4"></rect>
                      { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <rect height="18px" width="2.5px" stroke="white" strokeWidth="0.5" fill="grey" rx="1" x={`${data.past.weightedDistribution[4]/data.past.totalWeight * 100}%`}></rect>}
                    </svg>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col span={10}>
                    <strong><FormattedMessage id="app.agree"/></strong>
                  </Col>
                  <Col span={6}>
                    <strong>{Math.round(data.weightedDistribution[3]/data.totalWeight * 100)}%</strong> { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <small>vs. {Math.round(data.past.weightedDistribution[3]/data.past.totalWeight * 100)}%</small>}
                  </Col>
                  <Col span={8}>
                    <svg height="18px" width="100%">
                      <rect height="18px" width="100%" fill="#efefef" rx="4"></rect>
                      <rect height="18px" width={`${data.weightedDistribution[3]/data.totalWeight * 100}%`} fill={data.mainColor} rx="4"></rect>
                      { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <rect height="18px" width="2.5px" stroke="white" strokeWidth="0.5" fill="grey" rx="1" x={`${data.past.weightedDistribution[3]/data.past.totalWeight * 100}%`}></rect>}
                    </svg>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col span={10}>
                    <strong><FormattedMessage id="app.neutral"/></strong>
                  </Col>
                  <Col span={6}>
                    <strong>{Math.round(data.weightedDistribution[2]/data.totalWeight * 100)}%</strong> { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <small>vs. {Math.round(data.past.weightedDistribution[2]/data.past.totalWeight * 100)}%</small>}
                  </Col>
                  <Col span={8}>
                    <svg height="18px" width="100%">
                      <rect height="18px" width="100%" fill="#efefef" rx="4"></rect>
                      <rect height="18px" width={`${data.weightedDistribution[2]/data.totalWeight * 100}%`} fill={data.mainColor} rx="4"></rect>
                      { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <rect height="18px" width="2.5px" stroke="white" strokeWidth="0.5" fill="grey" rx="1" x={`${data.past.weightedDistribution[2]/data.past.totalWeight * 100}%`}></rect>}
                    </svg>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col span={10}>
                    <strong><FormattedMessage id="app.disagree"/></strong>
                  </Col>
                  <Col span={6}>
                    <strong>{Math.round(data.weightedDistribution[1]/data.totalWeight * 100)}%</strong> { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <small>vs. {Math.round(data.past.weightedDistribution[1]/data.past.totalWeight * 100)}%</small>}
                  </Col>
                  <Col span={8}>
                    <svg height="18px" width="100%">
                      <rect height="18px" width="100%" fill="#efefef" rx="4"></rect>
                      <rect height="18px" width={`${data.weightedDistribution[1]/data.totalWeight * 100}%`} fill={data.mainColor} rx="4"></rect>
                      { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <rect height="18px" width="2.5px" stroke="white" strokeWidth="0.5" fill="grey" rx="1" x={`${data.past.weightedDistribution[1]/data.past.totalWeight * 100}%`}></rect>}
                    </svg>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col span={10}>
                    <strong><FormattedMessage id="app.stronglyDisagree"/></strong>
                  </Col>
                  <Col span={6}>
                    <strong>{Math.round(data.weightedDistribution[0]/data.totalWeight * 100)}%</strong> { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <small>vs. {Math.round(data.past.weightedDistribution[0]/data.past.totalWeight * 100)}%</small>}
                  </Col>
                  <Col span={8}>
                    <svg height="18px" width="100%">
                      <rect height="18px" width="100%" fill="#efefef" rx="4"></rect>
                      <rect height="18px" width={`${data.weightedDistribution[0]/data.totalWeight * 100}%`} fill={data.mainColor} rx="4"></rect>
                      <rect height="18px" width="2.5px" stroke="white" strokeWidth="0.5" fill="grey" rx="1" x={`${data.past.weightedDistribution[0]/data.past.totalWeight * 100}%`}></rect>
                    </svg>
                  </Col>
                </Row>
              </div>
            }
            {
              (data.question.type === 'agreementLevel' && PARAM_DETAIL_LEVEL === 3) && 
              <div style={{ paddingLeft: 8 }}>
                <Row type="flex">
                  <Col span={6}>
                    <strong><FormattedMessage id="app.agree"/></strong>
                  </Col>
                  <Col span={6}>
                    <strong>{Math.round((data.weightedDistribution[4] + data.weightedDistribution[3])/data.totalWeight * 100)}%</strong> { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <small>vs. {Math.round((data.past.weightedDistribution[4] + data.past.weightedDistribution[3])/data.past.totalWeight * 100)}%</small>}
                  </Col>
                  <Col span={12}>
                    <svg height="18px" width="100%">
                      <rect height="18px" width="100%" fill="#efefef" rx="4"></rect>
                      <rect height="18px" width={`${(data.weightedDistribution[4] + data.weightedDistribution[3])/data.totalWeight * 100}%`} fill={data.mainColor} rx="4"></rect>
                      { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <rect height="18px" width="2.5px" stroke="white" strokeWidth="0.5" fill="grey" rx="1" x={`${(data.past.weightedDistribution[4] + data.past.weightedDistribution[3])/data.past.totalWeight * 100}%`}></rect>}
                    </svg>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col span={6}>
                    <strong><FormattedMessage id="app.neutral"/></strong>
                  </Col>
                  <Col span={6}>
                    <strong>{Math.round(data.weightedDistribution[2]/data.totalWeight * 100)}%</strong> { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <small>vs. {Math.round(data.past.weightedDistribution[2]/data.past.totalWeight * 100)}%</small>}
                  </Col>
                  <Col span={12}>
                    <svg height="18px" width="100%">
                      <rect height="18px" width="100%" fill="#efefef" rx="4"></rect>
                      <rect height="18px" width={`${data.weightedDistribution[2]/data.totalWeight * 100}%`} fill={data.mainColor} rx="4"></rect>
                      { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <rect height="18px" width="2.5px" stroke="white" strokeWidth="0.5" fill="grey" rx="1" x={`${data.past.weightedDistribution[2]/data.past.totalWeight * 100}%`}></rect>}
                    </svg>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col span={6}>
                    <strong><FormattedMessage id="app.disagree"/></strong>
                  </Col>
                  <Col span={6}>
                    <strong>{Math.round((data.weightedDistribution[1]+data.weightedDistribution[0])/data.totalWeight * 100)}%</strong> { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <small>vs. {Math.round((data.past.weightedDistribution[1] + data.past.weightedDistribution[0])/data.past.totalWeight * 100)}%</small>}
                  </Col>
                  <Col span={12}>
                    <svg height="18px" width="100%">
                      <rect height="18px" width="100%" fill="#efefef" rx="4"></rect>
                      <rect height="18px" width={`${(data.weightedDistribution[1]+data.weightedDistribution[0])/data.totalWeight * 100}%`} fill={data.mainColor} rx="4"></rect>
                      { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <rect height="18px" width="2.5px" stroke="white" strokeWidth="0.5" fill="grey" rx="1" x={`${(data.past.weightedDistribution[1]+data.past.weightedDistribution[0])/data.past.totalWeight * 100}%`}></rect>}
                    </svg>
                  </Col>
                </Row>
                {
                  data.question.extraCategoryLabel && 
                  <Row type="flex">
                    <Col span={6}>
                      <strong>{data.question.extraCategoryLabel}</strong>
                    </Col>
                    <Col span={6}>
                      <strong>{Math.round(data.weightedDistribution[5]/data.totalWeight * 100)}%</strong> { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <small>vs. {Math.round(data.past.weightedDistribution[5]/data.past.totalWeight * 100)}%</small>}
                    </Col>
                    <Col span={12}>
                      <svg height="18px" width="100%">
                        <rect height="18px" width="100%" fill="#efefef" rx="4"></rect>
                        <rect height="18px" width={`${data.weightedDistribution[5]/data.totalWeight * 100}%`} fill={data.mainColor} rx="4"></rect>
                        { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <rect height="18px" width="2.5px" stroke="white" strokeWidth="0.5" fill="grey" rx="1" x={`${data.past.weightedDistribution[5]/data.past.totalWeight * 100}%`}></rect>}
                      </svg>
                    </Col>
                  </Row>
                }
              </div>
            }
            {
              data.question.type.startsWith('agreementLevel3') && 
              <div style={{ paddingLeft: 8 }}>
                <Row type="flex">
                  <Col span={6}>
                    <strong><FormattedMessage id="app.wantToBeInvolved"/></strong>
                  </Col>
                  <Col span={6}>
                    <strong>{Math.round(data.weightedDistribution[2]/data.totalWeight * 100)}%</strong> { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <small>vs. {Math.round(data.past.weightedDistribution[2]/data.past.totalWeight * 100)}%</small>}
                  </Col>
                  <Col span={12}>
                    <svg height="18px" width="100%">
                      <rect height="18px" width="100%" fill="#efefef" rx="4"></rect>
                      <rect height="18px" width={`${data.weightedDistribution[2]/data.totalWeight * 100}%`} fill={data.mainColor} rx="4"></rect>
                      { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <rect height="18px" width="2.5px" stroke="white" strokeWidth="0.5" fill="grey" rx="1" x={`${data.past.weightedDistribution[2]/data.past.totalWeight * 100}%`}></rect>}
                    </svg>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col span={6}>
                    <strong><FormattedMessage id="app.fine"/></strong>
                  </Col>
                  <Col span={6}>
                    <strong>{Math.round(data.weightedDistribution[1]/data.totalWeight * 100)}%</strong> { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <small>vs. {Math.round(data.past.weightedDistribution[1]/data.past.totalWeight * 100)}%</small>}
                  </Col>
                  <Col span={12}>
                    <svg height="18px" width="100%">
                      <rect height="18px" width="100%" fill="#efefef" rx="4"></rect>
                      <rect height="18px" width={`${data.weightedDistribution[1]/data.totalWeight * 100}%`} fill={data.mainColor} rx="4"></rect>
                      { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <rect height="18px" width="2.5px" stroke="white" strokeWidth="0.5" fill="grey" rx="1" x={`${data.past.weightedDistribution[1]/data.past.totalWeight * 100}%`}></rect>}
                    </svg>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col span={6}>
                    <strong><FormattedMessage id="app.notInterested"/></strong>
                  </Col>
                  <Col span={6}>
                    <strong>{Math.round(data.weightedDistribution[0]/data.totalWeight * 100)}%</strong> { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <small>vs. {Math.round(data.past.weightedDistribution[0]/data.past.totalWeight * 100)}%</small>}
                  </Col>
                  <Col span={12}>
                    <svg height="18px" width="100%">
                      <rect height="18px" width="100%" fill="#efefef" rx="4"></rect>
                      <rect height="18px" width={`${data.weightedDistribution[0]/data.totalWeight * 100}%`} fill={data.mainColor} rx="4"></rect>
                      { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <rect height="18px" width="2.5px" stroke="white" strokeWidth="0.5" fill="grey" rx="1" x={`${data.past.weightedDistribution[0]/data.past.totalWeight * 100}%`}></rect>}
                    </svg>
                  </Col>
                </Row>
              </div>
            }
            {
              data.question.type === 'moreLess' && 
              <div style={{ paddingLeft: 8 }}>
                <Row type="flex">
                  <Col span={6}>
                    <strong><FormattedMessage id="app.more"/></strong>
                  </Col>
                  <Col span={6}>
                    <strong>{Math.round(data.weightedDistribution[2]/data.totalWeight * 100)}%</strong> { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <small>vs. {Math.round(data.past.weightedDistribution[2]/data.past.totalWeight * 100)}%</small>}
                  </Col>
                  <Col span={12}>
                    <svg height="18px" width="100%">
                      <rect height="18px" width="100%" fill="#efefef" rx="4"></rect>
                      <rect height="18px" width={`${data.weightedDistribution[2]/data.totalWeight * 100}%`} fill="#4CAF50" rx="4"></rect>
                      <rect height="18px" width="2.5px" stroke="white" strokeWidth="0.5" fill="grey" rx="1" x={`${data.past.weightedDistribution[2]/data.past.totalWeight * 100}%`}></rect>
                    </svg>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col span={6}>
                    <strong><FormattedMessage id="app.neutral"/></strong>
                  </Col>
                  <Col span={6}>
                    <strong>{Math.round(data.weightedDistribution[1]/data.totalWeight * 100)}%</strong> { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <small>vs. {Math.round(data.past.weightedDistribution[1]/data.past.totalWeight * 100)}%</small>}
                  </Col>
                  <Col span={12}>
                    <svg height="18px" width="100%">
                      <rect height="18px" width="100%" fill="#efefef" rx="4"></rect>
                      <rect height="18px" width={`${data.weightedDistribution[1]/data.totalWeight * 100}%`} fill="grey" rx="4"></rect>
                      <rect height="18px" width="2.5px" stroke="white" strokeWidth="0.5" fill="grey" rx="1" x={`${data.past.weightedDistribution[1]/data.past.totalWeight * 100}%`}></rect>
                    </svg>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col span={6}>
                    <strong><FormattedMessage id="app.less"/></strong>
                  </Col>
                  <Col span={6}>
                    <strong>{Math.round(data.weightedDistribution[0]/data.totalWeight * 100)}%</strong> { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <small>vs. {Math.round(data.past.weightedDistribution[0]/data.past.totalWeight * 100)}%</small>}
                  </Col>
                  <Col span={12}>
                    <svg height="18px" width="100%">
                      <rect height="18px" width="100%" fill="#efefef" rx="4"></rect>
                      <rect height="18px" width={`${data.weightedDistribution[0]/data.totalWeight * 100}%`} fill="#f44336" rx="4"></rect>
                      <rect height="18px" width="2.5px" stroke="white" strokeWidth="0.5" fill="grey" rx="1" x={`${data.past.weightedDistribution[0]/data.past.totalWeight * 100}%`}></rect>
                    </svg>
                  </Col>
                </Row>
              </div>
            }
            {
              data.question.type === 'yesNo' && 
              <div style={{ paddingLeft: 8 }}>
                <Row type="flex">
                  <Col span={6}>
                    <strong><FormattedMessage id="app.agree"/></strong>
                  </Col>
                  <Col span={6}>
                    <strong>{Math.round(data.weightedDistribution[1]/data.totalWeight * 100)}%</strong> { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <small>vs. {Math.round(data.past.weightedDistribution[1]/data.past.totalWeight * 100)}%</small>}
                  </Col>
                  <Col span={12}>
                    <svg height="18px" width="100%">
                      <rect height="18px" width="100%" fill="#efefef" rx="4"></rect>
                      <rect height="18px" width={`${data.weightedDistribution[1]/data.totalWeight * 100}%`} fill={data.mainColor} rx="4"></rect>
                      { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <rect height="18px" width="2.5px" stroke="white" strokeWidth="0.5" fill="grey" rx="1" x={`${data.past.weightedDistribution[1]/data.past.totalWeight * 100}%`}></rect>}
                    </svg>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col span={6}>
                    <strong><FormattedMessage id="app.disagree"/></strong>
                  </Col>
                  <Col span={6}>
                    <strong>{Math.round(data.weightedDistribution[0]/data.totalWeight * 100)}%</strong> { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <small>vs. {Math.round(data.past.weightedDistribution[0]/data.past.totalWeight * 100)}%</small>}
                  </Col>
                  <Col span={12}>
                    <svg height="18px" width="100%">
                      <rect height="18px" width="100%" fill="#efefef" rx="4"></rect>
                      <rect height="18px" width={`${data.weightedDistribution[0]/data.totalWeight * 100}%`} fill={data.mainColor} rx="4"></rect>
                      { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <rect height="18px" width="2.5px" stroke="white" strokeWidth="0.5" fill="grey" rx="1" x={`${data.past.weightedDistribution[0]/data.past.totalWeight * 100}%`}></rect>}
                    </svg>
                  </Col>
                </Row>
              </div>
            }
            {
              data.question.type === 'binary' && 
              <div style={{ paddingLeft: 8 }}>
                <Row type="flex">
                  <Col span={6}>
                    <strong><FormattedMessage id="app.yes"/></strong>
                  </Col>
                  <Col span={6}>
                    <strong>{Math.round(data.weightedDistribution[0]/data.totalWeight * 100)}%</strong> { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <small>vs. {Math.round(data.past.weightedDistribution[0]/data.past.totalWeight * 100)}%</small>}
                  </Col>
                  <Col span={12}>
                    <svg height="18px" width="100%">
                      <rect height="18px" width="100%" fill="#efefef" rx="4"></rect>
                      <rect height="18px" width={`${data.weightedDistribution[0]/data.totalWeight * 100}%`} fill={data.mainColor} rx="4"></rect>
                      { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <rect height="18px" width="2.5px" stroke="white" strokeWidth="0.5" fill="grey" rx="1" x={`${data.past.weightedDistribution[0]/data.past.totalWeight * 100}%`}></rect>}
                    </svg>
                  </Col>
                </Row>
                <Row type="flex">
                  <Col span={6}>
                    <strong><FormattedMessage id="app.no"/></strong>
                  </Col>
                  <Col span={6}>
                    <strong>{Math.round(data.weightedDistribution[1]/data.totalWeight * 100)}%</strong> { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <small>vs. {Math.round(data.past.weightedDistribution[1]/data.past.totalWeight * 100)}%</small>}
                  </Col>
                  <Col span={12}>
                    <svg height="18px" width="100%">
                      <rect height="18px" width="100%" fill="#efefef" rx="4"></rect>
                      <rect height="18px" width={`${data.weightedDistribution[1]/data.totalWeight * 100}%`} fill={data.mainColor} rx="4"></rect>
                      { (!data.question.noEvolution && data.pastCityMetricProportion !== null) && <rect height="18px" width="2.5px" stroke="white" strokeWidth="0.5" fill="grey" rx="1" x={`${data.past.weightedDistribution[1]/data.past.totalWeight * 100}%`}></rect>}
                    </svg>
                  </Col>
                </Row>
              </div>
            }
            {
              city !== 'all' &&
              <div style={{ paddingTop: 8 }}>
                <h5><FormattedMessage id="app.geo"/> (<FormattedMessage id="app.agreementRatio"/> {PARAM_ADVANCE_MODE && <span> | <FormattedMessage id="app.averageScore"/></span>})</h5>
                <Row type="flex" style={{ paddingLeft: 8 }} justify="start">
                  {Object.keys(data.regions).map(k => {
                    return <Col span={24} key={k}><strong>{regionLabels[k][locale]}</strong>: {numeral(data.regions[k].weightedAgreementProportion).format('0 %')} {PARAM_ADVANCE_MODE && <span> | {numeral(data.regions[k].weightedAvg).format('0.0')}</span>} </Col>
                  })}
                </Row>
              </div>
            }
          </div>
        }
      </div>
    );
  }
  return null; // null when hidden (or missing data = at the beginning only)
}

export default injectIntl(ComparisonSimpleTooltip);